export default {
  familyName: 'Helvetica Neue',
  fullName: 'Helvetica Neue',
  postscriptName: 'HelveticaNeue',
  category: 'sans-serif',
  capHeight: 714,
  ascent: 952,
  descent: -213,
  lineGap: 28,
  unitsPerEm: 1000,
  xHeight: 517,
  xWidthAvg: 450,
  subsets: {
    latin: {
      xWidthAvg: 450
    },
    thai: {
      xWidthAvg: 364
    }
  }
};
